module.exports = __webpack_public_path__ + "img/tool_icon5.8da09e48.svg";